/**
 * Unit of Measure (UOM) Constants
 * Single source of truth for UOM options in the frontend.
 * 
 * To add new units: just extend the UOM_OPTIONS array.
 * The backend validates against its own constant, so keep both in sync.
 */

export const UOM_OPTIONS = [
  { code: 'ea', label: 'Each' },
  { code: 'ft', label: 'Foot' },
  { code: 'in', label: 'Inch' },
  { code: 'yd', label: 'Yard' },
  { code: 'lb', label: 'Pound' },
  { code: 'gal', label: 'Gallon' },
  { code: 'box', label: 'Box' },
];

export const DEFAULT_UOM = 'ea';

/**
 * Get the label for a UOM code
 * @param {string} code - UOM code (e.g., 'ft', 'ea')
 * @returns {string} Label (e.g., 'Foot', 'Each') or the code if not found
 */
export const getUomLabel = (code) => {
  const uom = UOM_OPTIONS.find(u => u.code === code);
  return uom ? uom.label : code || 'ea';
};

/**
 * Format a quantity with its UOM for display
 * @param {number|string} quantity - The quantity value
 * @param {string} uom - UOM code
 * @returns {string} Formatted string like "12.5 ft" or "3 ea"
 */
export const formatQuantityWithUom = (quantity, uom = 'ea') => {
  if (quantity === null || quantity === undefined) return '-';
  
  // Format the number - remove trailing zeros for whole numbers
  const numValue = parseFloat(quantity);
  const formatted = Number.isInteger(numValue) 
    ? numValue.toString() 
    : numValue.toFixed(3).replace(/\.?0+$/, '');
  
  return `${formatted} ${uom}`;
};
